import { render } from "./BarCode.vue?vue&type=template&id=43e65140&scoped=true"
import script from "./BarCode.vue?vue&type=script&lang=js"
export * from "./BarCode.vue?vue&type=script&lang=js"

import "./BarCode.vue?vue&type=style&index=0&id=43e65140&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43e65140"]])

export default __exports__